export default function Section10() {
    const points = [
        {
            title: "Local Expertise",
            description:
                "We understand how UAE customers think and act online. Our CRO strategies are adapted to local buyer behavior and expectations.",
        },
        {
            title: "Proven Results",
            description:
                "Our clients across Dubai and Abu Dhabi have seen significant conversion increases within months of working with us.",
        },
        {
            title: "Transparent Process",
            description:
                "No confusing reports or guesswork. You get clear insights and measurable results.",
        },
        {
            title: "Full-Service Support",
            description:
                "We manage everything from audits to implementation and ongoing optimization.",
        },
        {
            title: "Bilingual CRO Expertise",
            description:
                "We optimize websites in both English and Arabic to reach a wider UAE audience effectively.",
        },
    ];

    return (
        <div className="SectionCRO py-[40px] md:py-[50px] bg-[#f9f9f9]">
            {/* Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Why Choose Mean3 for CRO in the UAE
                </h2>
            </div>

            {/* Cards with centered next row */}
            <div className="flex flex-wrap justify-center gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {points.map((point, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition w-full sm:w-[45%] md:w-[28%] ${index % 2 === 0
                                ? "bg-[#E42E35] text-white"
                                : "bg-white text-[#151515] border border-gray-200"
                            }`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {point.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {point.description}
                        </p>
                    </div>
                ))}
            </div>
        </div>
    );
}
